"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preprocessHtmlContent = void 0;
/**
 * Preprocess HTML content to replace </p> <p> with <br> and all empty <p> tags with <br>.
 * @param {string} content - The HTML content to preprocess.
 * @returns {string} - The preprocessed HTML content.
 */
exports.preprocessHtmlContent = function (content) {
    // Replace empty <div></div> tags (with or without attributes) with <br>
    var updatedContent = content.replace(/<div[^>]*>\s*<\/div>/g, '<br>');
    // Replace empty <p> tags with <br>, handling attributes and whitespace
    updatedContent = updatedContent.replace(/<p[^>]*>\s*(?:&nbsp;|\u00A0)?\s*<\/p>/g, '<br>');
    return updatedContent;
};
